(() => {
  const panel = document.getElementById('riot-collection-refine');
  const grid = document.getElementById('riot-collection-grid');
  if (!panel || !grid || panel.dataset.initialized) return;
  panel.dataset.initialized = 'true';
  const fields = Array.from(panel.querySelectorAll('[data-refine]'));
  const count = panel.querySelector('[data-refine-count]');
  const clear = panel.querySelector('[data-refine-clear]');
  const loading = panel.querySelector('[data-refine-loading]');
  const error = panel.querySelector('[data-refine-error]');
  const empty = panel.querySelector('[data-refine-empty]');
  const more = document.querySelector('[data-riot-more]');
  const pagination = document.querySelector('[data-riot-pagination]');
  const modals = document.querySelector('[data-riot-modals]');
  const labels = JSON.parse(panel.querySelector('[data-refine-labels]').textContent);
  const cards = new Map(Array.from(grid.children).map(card => [card.dataset.productHandle, card]));
  const cardRequests = new Map();
  const indexes = new Map();
  const pageSize = Number(panel.dataset.pageSize) || 28;
  const columnCount = grid.dataset.columns || '4';
  const base = new URL(panel.dataset.collectionUrl, location.origin);
  const catalog = new URL(panel.dataset.catalogUrl, location.origin);
  let products = [], catalogProducts = [], indexSort = '', shown = pageSize, generation = 0, ready = false;
  let retryAction = null;
  const field = key => fields.find(input => input.dataset.refine === key);
  const values = () => Object.fromEntries(fields.map(input => [input.dataset.refine, input.value]));
  const normalize = value => String(value).trim().replace(/\s*\/\s*/g, '/').toUpperCase();
  const availability = (variant, choice, size) => {
    if (choice === 'now') return variant.stock;
    if (choice === 'preorder') return !variant.stock && variant.preorder;
    return !size || variant.stock || variant.preorder;
  };
  function matches(product, choices) {
    if (choices.style && product.style !== choices.style) return false;
    if (choices.coverage && product.coverage !== choices.coverage) return false;
    return product.variants.some(variant => {
      if (choices.size && normalize(variant.size) !== normalize(choices.size) && !normalize(variant.size).split('/').includes(normalize(choices.size))) return false;
      if (choices.color && variant.color !== choices.color) return false;
      if (choices.min && variant.price < Number(choices.min) * 100) return false;
      if (choices.max && variant.price > Number(choices.max) * 100) return false;
      return availability(variant, choices.availability, choices.size);
    });
  }
  function endpoint(url, view, page, sort) {
    const target = new URL(url);
    target.searchParams.set('view', view);
    target.searchParams.set('page', page);
    if (sort) target.searchParams.set('sort_by', sort);
    return target;
  }
  async function readIndex(url, sort) {
    const all = [];
    let pages = 1;
    for (let page = 1; page <= pages; page++) {
      const response = await fetch(endpoint(url, 'riot-refine-data', page, sort), { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Collection filter data unavailable');
      const data = await response.json();
      if (!Array.isArray(data.products) || data.page !== page) throw new Error('Collection filter data incomplete');
      pages = data.pages;
      all.push(...data.products);
    }
    return all;
  }
  async function indexFor(sort) {
    if (!indexes.has(sort)) {
      indexes.set(sort, readIndex(base, sort).catch(reason => { indexes.delete(sort); throw reason; }));
    }
    let entries = await indexes.get(sort);
    if (window.riotCollectionSelection) {
      const comparators = {
        'title-ascending': (a, b) => a.title.localeCompare(b.title),
        'title-descending': (a, b) => b.title.localeCompare(a.title),
        'price-ascending': (a, b) => Math.min(...a.variants.map(v => v.price)) - Math.min(...b.variants.map(v => v.price)),
        'price-descending': (a, b) => Math.min(...b.variants.map(v => v.price)) - Math.min(...a.variants.map(v => v.price)),
        'created-ascending': (a, b) => Number(a.created) - Number(b.created),
        'created-descending': (a, b) => Number(b.created) - Number(a.created)
      };
      if (comparators[sort]) entries = entries.slice().sort(comparators[sort]);
      if (sort === 'best-selling') {
        const salesRanks = new Map(window.riotCollectionSalesOrder.map((handle, position) => [handle, position]));
        entries = entries.slice().sort((a, b) => (salesRanks.get(a.handle) ?? 9999) - (salesRanks.get(b.handle) ?? 9999));
      }
    }
    if (window.riotCollectionOrder && sort === 'manual') {
      const ranks = new Map(window.riotCollectionOrder.map((handle, position) => [handle, position]));
      entries = entries.slice().sort((a, b) => (ranks.get(a.handle) ?? 9999) - (ranks.get(b.handle) ?? 9999));
    }
    return entries;
  }
  function options(input, entries, labelFor, disabledFor) {
    const previous = input.value;
    const first = input.options[0].cloneNode(true);
    input.replaceChildren(first);
    entries.forEach(value => {
      const option = document.createElement('option');
      option.value = value;
      option.textContent = labelFor ? labelFor(value) : value;
      option.disabled = disabledFor ? disabledFor(value) : false;
      input.appendChild(option);
    });
    input.value = previous;
  }
  function populate() {
    const sizeOrder = ['XXS', 'XS', 'S', 'S/M', 'M', 'M/L', 'L', 'L/XL', 'XL', 'XXL', '2XL', '3XL'];
    const sizes = [...new Set(products.flatMap(product => product.variants.map(variant => normalize(variant.size))).filter(Boolean))];
    sizes.sort((a, b) => {
      const ai = sizeOrder.indexOf(a), bi = sizeOrder.indexOf(b);
      return (ai === -1 ? 100 : ai) - (bi === -1 ? 100 : bi) || a.localeCompare(b);
    });
    options(field('size'), sizes);
    const localColors = new Set(products.flatMap(product => product.variants.map(variant => variant.color)).filter(Boolean));
    const colors = [...new Set(catalogProducts.concat(products).flatMap(product => product.variants.map(variant => variant.color)).filter(Boolean))].sort((a, b) => a.localeCompare(b));
    options(field('color'), colors, color => localColors.has(color) ? color : color + ' (' + labels.unavailable + ')', color => !localColors.has(color));
    const styles = [...new Set(products.map(product => product.style).filter(Boolean))].sort();
    options(field('style'), styles, style => style.replace(/\b\w/g, letter => letter.toUpperCase()));
    const coverages = new Set(products.map(product => product.coverage).filter(Boolean));
    panel.querySelector('[data-riot-coverage]').hidden = coverages.size === 0;
    Array.from(field('coverage').options).forEach(option => { option.disabled = !!option.value && !coverages.has(option.value); });
  }
  function restore() {
    const params = new URLSearchParams(location.search);
    fields.forEach(input => {
      const key = input.dataset.refine;
      const value = params.get(key === 'sort' ? 'sort_by' : 'riot_' + key);
      input.value = value || (key === 'sort' ? panel.dataset.defaultSort : '');
    });
    if (fields.some(input => input.dataset.refine !== 'sort' && input.value)) panel.querySelector('details').open = true;
  }
  function updateUrl(choices) {
    const url = new URL(location.href);
    url.searchParams.delete('page');
    fields.forEach(input => {
      const key = input.dataset.refine;
      const param = key === 'sort' ? 'sort_by' : 'riot_' + key;
      if (choices[key] && (key !== 'sort' || choices[key] !== panel.dataset.defaultSort)) url.searchParams.set(param, choices[key]);
      else url.searchParams.delete(param);
    });
    history.replaceState({}, '', url);
  }
  async function loadCards(page, sort) {
    const key = sort + ':' + page;
    if (!cardRequests.has(key)) {
      cardRequests.set(key, (async () => {
        const response = await fetch(endpoint(base, 'riot-refine-cards', page, sort), { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Collection cards unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const templates = Array.from(doc.querySelectorAll('template[data-riot-card]'));
        if (!templates.length) throw new Error('Collection cards incomplete');
        templates.forEach(template => {
          const handle = template.dataset.riotCard;
          if (cards.has(handle)) return;
          const card = template.content.querySelector('.grid-product');
          if (!card) return;
          card.dataset.aos = 'row-of-' + columnCount;
          cards.set(handle, card);
        });
        doc.querySelectorAll('template[data-riot-modal]').forEach(template => {
          const modal = template.content.firstElementChild;
          if (modal && !document.getElementById(modal.id)) modals.appendChild(modal);
        });
      })().catch(reason => { cardRequests.delete(key); throw reason; }));
    }
    return cardRequests.get(key);
  }
  function busy(on) {
    loading.hidden = !on;
    grid.setAttribute('aria-busy', String(on));
    more.disabled = on;
  }
  async function render(writeUrl = true) {
    if (!ready) return;
    const request = ++generation;
    const choices = values();
    const active = fields.some(input => input.dataset.refine !== 'sort' && input.value);
    clear.hidden = !active && choices.sort === panel.dataset.defaultSort;
    error.hidden = true;
    busy(true);
    retryAction = () => render(writeUrl);
    try {
      if (indexSort !== choices.sort) {
        const next = await indexFor(choices.sort);
        if (request !== generation) return;
        products = next;
        indexSort = choices.sort;
      }
      const results = products.filter(product => matches(product, choices));
      const visible = results.slice(0, shown);
      const missingPages = [...new Set(visible.filter(product => !cards.has(product.handle)).map(product => product.page))];
      for (let index = 0; index < missingPages.length; index += 3) {
        await Promise.all(missingPages.slice(index, index + 3).map(page => loadCards(page, indexSort)));
      }
      if (request !== generation) return;
      if (visible.some(product => !cards.has(product.handle))) throw new Error('Matching collection cards missing');
      const fragment = document.createDocumentFragment();
      visible.forEach(product => {
        const card = cards.get(product.handle);
        card.hidden = false;
        fragment.appendChild(card);
      });
      grid.replaceChildren(fragment);
      count.textContent = (results.length === 1 ? labels.single : labels.plural).replace('__COUNT__', results.length);
      empty.hidden = results.length !== 0;
      more.parentElement.hidden = results.length <= shown;
      pagination.hidden = true;
      if (writeUrl) updateUrl(choices);
      if (window.theme && theme.reinitProductGridItem) theme.reinitProductGridItem(grid);
      document.dispatchEvent(new CustomEvent('riot:collection:updated'));
    } catch (reason) {
      if (request === generation) error.hidden = false;
    } finally {
      if (request === generation) busy(false);
    }
  }
  async function init() {
    error.hidden = true;
    busy(true);
    retryAction = init;
    try {
      const sort = new URLSearchParams(location.search).get('sort_by') || panel.dataset.defaultSort;
      const result = await Promise.all([indexFor(sort), readIndex(catalog, '').catch(() => [])]);
      products = result[0];
      catalogProducts = result[1];
      indexSort = sort;
      populate();
      restore();
      fields.forEach(input => { input.disabled = false; });
      ready = true;
      await render();
    } catch (reason) {
      busy(false);
      error.hidden = false;
    }
  }
  fields.forEach(input => input.addEventListener('change', () => { shown = pageSize; render(); }));
  clear.addEventListener('click', () => {
    fields.forEach(input => { input.value = input.dataset.refine === 'sort' ? panel.dataset.defaultSort : ''; });
    shown = pageSize;
    render();
  });
  more.addEventListener('click', () => { shown += pageSize; render(); });
  panel.querySelector('[data-refine-retry]').addEventListener('click', () => { if (retryAction) retryAction(); });
  window.addEventListener('popstate', () => { restore(); shown = pageSize; render(false); });
  const details = panel.querySelector('details');
  details.addEventListener('toggle', () => { details.querySelector('summary').setAttribute('aria-expanded', String(details.open)); });
  init();
})();
